<template>
    <div class="alert-container">
        <ResultsAlertEmergencyCare />
        <ResultsAlertTravelNetwork />
        <ResultsAlertUnityPointChiropracterSpecialty />
        <ResultsAlertUnityPointOptometrySpecialty />
        <ResultsAlertBellin />
        <ResultsAlertDentalCoverage />
        <ResultsAlertPediatricDentalNetwork />
        <ResultsAlertTopValue />
        <ResultsAlertInterestedInCarePromo />
        <ResultsAlertReferencedBasedBenefits />
    </div>
  </template>
  
  <script setup>
  </script>
  
  <style scoped>
  .alert-container {
    display: grid;
    grid-template-columns: auto;
    padding-top: var(--spacing-xs);
    padding-bottom: var(--spacing-sm);
    row-gap: var(--spacing-xs);
  }
  </style>
  <style lang="scss">
  hp5-alert .alert-wrapper {
    width: auto;
  }
  </style>